var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stretch",class:{ 'nopointer':_vm.opacity === 0 },style:({ 'background-color':_vm.color, 'opacity':_vm.opacity })})}
var staticRenderFns = []

export { render, staticRenderFns }